// src/enhancers/btHolidayCopy.js  (改成全站通用 copy)
(function () {
  if (window.__btCopyGlobalInited) return;
  window.__btCopyGlobalInited = true;

  function fallbackCopy(code) {
    try {
      const ta = document.createElement("textarea");
      ta.value = code;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      ta.style.top = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (_) {
      return false;
    }
  }

  async function copyText(code) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        return true;
      }
    } catch (_) {}
    return fallbackCopy(code);
  }

  // ✅ 全站事件委派：任何元素只要有 data-copy 就能複製
  document.addEventListener("click", async (e) => {
    const el = e.target.closest("[data-copy]");
    if (!el) return;

    // 避免 <a> 跳頁
    e.preventDefault();

    const code = String(el.getAttribute("data-copy") || "").trim();
    if (!code) return;

    const ok = await copyText(code);

    // 最簡提示：先用 title/alert，後續你要統一 toast 我再補
    if (ok) {
      // 可用 title 或 aria-live（先簡化）
      el.setAttribute("title", "已複製：" + code);
      // 也可以加個小效果
      el.setAttribute("data-copied", "1");
      setTimeout(() => el.removeAttribute("data-copied"), 800);
    } else {
      alert("自動複製受限，請手動複製：" + code);
    }
  });
})();
